module.exports = __webpack_public_path__ + "static/media/look-around-iphone.1a935a1e.png";